<template>
  <footer class="site-footer enriched-footer">
    <div class="footer-main">
      <div class="footer-intro">
        <span>Customer Support</span>
        <p>Find order help, delivery details, return information, and accessibility resources in one place.</p>
        <div class="footer-badges">
          <b>Secure checkout</b>
          <b>30-day returns</b>
          <b>Weekly new arrivals</b>
        </div>
      </div>

      <div class="footer-links">
        <span>Customer Care</span>
        <router-link to="/shipping-policy">Shipping Policy</router-link>
        <router-link to="/return-policy">Return Policy</router-link>
        <router-link to="/accessibility-statement">Accessibility Statement</router-link>
        <router-link to="/login">Order Status</router-link>
      </div>

      <div class="footer-links">
        <span>Shop</span>
        <router-link :to="{ path: '/items', query: { category: 'Sweatshirts + Hoodies' } }">Sweatshirts + Hoodies</router-link>
        <router-link :to="{ path: '/items', query: { category: 'Jackets + Coats' } }">Jackets + Coats</router-link>
        <router-link :to="{ path: '/items', query: { category: 'Denim + Jeans' } }">Denim + Jeans</router-link>
        <router-link :to="{ path: '/items', query: { category: 'Graphic Tees' } }">Graphic Tees</router-link>
      </div>

      <div class="footer-links">
        <span>Help Topics</span>
        <router-link to="/login">Size Guide</router-link>
        <router-link to="/login">Payment Options</router-link>
        <router-link to="/login">Track a Package</router-link>
        <router-link to="/login">Store Credit</router-link>
      </div>
    </div>

    <div class="footer-service-row">
      <div>
        <strong>Free standard shipping</strong>
        <p>Available on eligible orders over $75.</p>
      </div>
      <div>
        <strong>Simple returns</strong>
        <p>Eligible items may be returned within 30 days.</p>
      </div>
      <div>
        <strong>Protected checkout</strong>
        <p>Payment flow is designed for secure order handling.</p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'SiteFooter'
}
</script>
